import qs from 'qs'

/**
 * 쿼리 파라미터를 `key=a&key=b` 로 직렬화한다. (ST02 `inventoryStatus/queryString.ts` 와 동일 근거)
 *
 * 공용 `Utils.qsStringify` 는 `arrayFormat: 'comma'` + `encode: false` 라 이 API 에 맞지 않는다 —
 * 브랜드명/상품명이 한글이라 인코딩이 필요하고, 값 자체에 콤마가 들어오면 comma 형식은 값이 쪼개진다.
 *
 * 빈 문자열은 제외한다 — EQUAL 필터에 빈 값이 걸리면 무결과가 된다.
 */
export const toRepeatQuery = <T extends object>(params: T): string =>
  qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true, filter: (_, value) => (value === '' ? undefined : value) })
